import React from 'react';
import cn from 'classnames';
import { ReactComponent as UploadSvg } from 'assets/icons/New/Upload.svg';
import ColumnActions from 'components/Antd/Table/ColumnActions';
import classes from './ComplianceData.module.scss';
import { GenerateFormContext } from './components/GenerateForms';

const Actions = () => {
  const { openForm } = React.useContext(GenerateFormContext);
  return (
    <ColumnActions
      color="default"
      className={cn(classes.columnActions)}
      dropdownOverlay={classes.dropdownOverlay}
      items={[
        {
          key: '1',
          label: (
            <>
              <span style={{ opacity: 0.5 }}>eFile Data to CPSC (US)</span>
            </>
          ),
          onClick: () => {},
          disabled: true,
        },
        {
          key: '2',
          label: (
            <>
              <span>Generate CPC (US)</span>
            </>
          ),
          onClick: () => {
            openForm('cpc', {
              title: 'Generate CPC (US)',
            });
          },
        },
        {
          key: '3',
          label: (
            <>
              <span>Generate GCC (US)</span>
            </>
          ),
          onClick: () => {
            openForm('gcc', {
              title: 'Generate GCC (US)',
            });
          },
        },
        {
          key: '4',
          label: (
            <>
              <span>Generate DoC (EU)</span>
            </>
          ),
          onClick: () => {
            openForm('doc', {
              title: ' Generate DoC (EU)',
            });
          },
        },
      ]}
    />
  );
};

export default Actions;
